import React, { FC } from 'react'
import Svg, { SvgProps } from '..'

interface SyzygyStripesProps extends SvgProps {
  width?: string
  height?: string
}

const SyzygyStripes: FC<SyzygyStripesProps> = ({
  style,
  width = '24px',
  height = width,
}) => {
  return (
    <Svg
      viewBox="0 0 45 45"
      className="syzygy-stripes-svg"
      style={style}
      width={width}
      height={height}
    >
      <circle
        className="syzygy-stripes__background"
        cx="22.5"
        cy="22.5"
        r="22.5"
      />
      <polygon
        className="syzygy-stripes__stripe"
        points="12.91 32.15 10.56 32.15 20.04 12.85 22.39 12.85 12.91 32.15"
      />
      <polygon
        className="syzygy-stripes__stripe"
        points="18.93 32.15 16.58 32.15 26.07 12.85 28.42 12.85 18.93 32.15"
      />
      <polygon
        className="syzygy-stripes__stripe"
        points="24.96 32.15 22.61 32.15 32.09 12.85 34.44 12.85 24.96 32.15"
      />
    </Svg>
  )
}

export default SyzygyStripes
